import { AxiosResponse } from 'axios';
import { instance as axios } from 'api/axios';
import { PhoneFormat, PhoneNumber, VerifyCode } from './interfaces';

export class PhoneService {
  public static formatPhone(phone: PhoneFormat) {
    return phone.replace(/(^\d{2})(\d{3})(\d{3})(\d{2})(\d{2}$)/g, '$1 ($2) $3-$4-$5');
  }

  public static async verifyPhone(phoneNumber: PhoneNumber) {
    try {
      const url = '/Message/Send';
      const response: AxiosResponse<VerifyCode> = await axios.post(url, phoneNumber);
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static unformatPhone(phone: string) {
    return phone.replace(/\D+/g, '');
  }
}
